@if (errorMessage()) {
  <div class="errorMessage">
    <pre>{{ errorMessage() }}</pre>
  </div>
}
<div class="content">
  @if (taskMessage()) {
    <div class="taskMessage">
      <p>{{ taskMessage() }}</p>
    </div>
  }
  @if (task() && task().baseTask) {
    <div class="taskDetail">
      <div class="displayRow">
        <span class="inputLabel">Task Name:</span>
        <span class="displayLabel">{{ task().baseTask.name }}</span>
      </div>
      <div class="displayRow">
        <span class="inputLabel">Started:</span>
        <span class="displayLabel">{{ task().baseTask.startTime | date: 'M/d/yyyy hh:mm a' }}</span>
      </div>
      @if (task().baseTask.escalationTime) {
        <div class="displayRow">
          <span class="inputLabel">Will Escalate:</span>
          <span class="displayLabel">{{ task().baseTask.escalationTime | date: 'M/d/yyyy hh:mm a' }}</span>
        </div>
      }
      @if (task().baseTask.autoCompleteTime) {
        <div class="displayRow">
          <span class="inputLabel">Will Autocomplete:</span>
          <span class="displayLabel">{{ task().baseTask.autoCompleteTime | date: 'M/d/yyyy hh:mm a' }}</span>
        </div>
      }
      <div class="displayRow">
        <span class="inputLabel">Assigned To:</span>
        <span class="displayLabel">{{ assignedTo() }}</span>
      </div>
    </div>
  }
  @if (entity()) {
    <div class="entityDetail">
      <div class="displayRow">
        <span class="inputLabel">Entity ID:</span>
        <a class="displayLabel" [href]="getEntityUrl()">{{ entity().id.entityId + ';' + entity().id.entityRevision }}</a>
      </div>
      <div class="displayRow">
        <span class="inputLabel">Project:</span>
        <span class="displayLabel">{{ entity().projectName }}</span>
      </div>
    </div>
  }
  @if (task() && task().baseTask) {
    <div class="fpa-data">
      <div class="displayRow">
        <span class="inputLabel">Outside Sales Rep:</span>
        <span class="displayLabel">{{ task().outsideSalesRep }}</span>
      </div>
      <div class="displayRow">
        <span class="inputLabel">Rep Office:</span>
        <span class="displayLabel">{{ task().repOffice }}</span>
      </div>
      <div class="displayRow">
        <span class="inputLabel">Lead Time:</span>
        <span class="displayLabel">{{ task().leadTime }}</span>
      </div>
      <div class="displayRow">
        <span class="inputLabel">Total List:</span>
        <span class="displayLabel">{{ task().totalList | currency: 'USD' }}</span>
      </div>
      <div class="displayRow">
        <span class="inputLabel">Unit Qty:</span>
        <span class="displayLabel">{{ task().unitQuantity }}</span>
      </div>
      <div class="displayRow">
        <span class="inputLabel">Published Multiplier:</span>
        <span class="displayLabel">{{ task().publishedMultiplier }}</span>
      </div>
      <div class="displayRow">
        <span class="inputLabel">Original Requested Multiplier:</span>
        <span class="displayLabel">{{ task().initialRequestMultiplier }}</span>
      </div>
      <div class="displayRow">
        <span class="inputLabel">Requested Multiplier:</span>
        <input class="input-field" [disabled]="isBusy()" [(ngModel)]="requestedMultiplier" />
      </div>
      <div class="displayRow">
        <span class="inputLabel">Margin &#64; Req Mult:</span>
        <span class="displayLabel">{{ task().margin }}</span>
      </div>
      <div class="displayRow">
        <span class="inputLabel">Sale Type:</span>
        <span class="displayLabel">{{ task().saleType }}</span>
      </div>
      <div class="displayRow">
        <span class="inputLabel">Approval Status:</span>
        <span class="displayLabel">{{ task().approvalStatus }}</span>
      </div>
      <div class="displayRow">
        <span class="inputLabel">Expected First Shipment:</span>
        <span class="displayLabel">{{ task().expectedFirstShipment }}</span>
      </div>
      <div class="displayRow">
        <span class="inputLabel">Basis Of Design:</span>
        <span class="displayLabel">{{ task().basisOfDesign }}</span>
      </div>
      <div class="displayRow">
        <span class="inputLabel">Competitor:</span>
        <span class="displayLabel">{{ task().competitor }}</span>
      </div>
      <div class="displayRow">
        <span class="inputLabel">Specifying Engineer:</span>
        <span class="displayLabel">{{ task().specifyingEngineer }}</span>
      </div>
      <div class="displayRow">
        <span class="inputLabel">Engineer Location:</span>
        <span class="displayLabel">{{ task().engineerLocation }}</span>
      </div>
      <div class="displayRow">
        <span class="inputLabel">Bid Date:</span>
        <span class="displayLabel">{{ task().bidDate }}</span>
      </div>
      <div class="displayRow">
        <span class="inputLabel">Other Details:</span>
        <span class="displayLabel">{{ task().otherDetails }}</span>
      </div>
      <div class="displayRow">
        <span class="inputLabel text-area-label">Comments:</span>
        <textarea rows="4" cols="80" class="no-resize" [(ngModel)]="comments"></textarea>
      </div>
    </div>
  }
  @if (canCloseTask()) {
    <div class="buttonRow">
      <span class="inputLabel"></span>
      <button matButton="elevated" class="buttonInput approveButton" (click)="closeTask(true)">
        <span>
          <mat-icon class="size-16">done</mat-icon>
          <span class="buttonLabel">Approve</span>
        </span>
      </button>
      <button matButton="elevated" class="buttonInput denyButton" (click)="closeTask(false)">
        <span>
          <mat-icon class="size-16">cancel</mat-icon>
          <span class="buttonLabel">Deny</span>
        </span>
      </button>
    </div>
  }
</div>
@if (isBusy()) {
  <div class="busyIndicator">
    <div class="busyContents">
      <mat-progress-spinner diameter="48" mode="indeterminate"></mat-progress-spinner>
      <span class="busyLabel">Please Wait...</span>
    </div>
  </div>
}

